import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

import { GlossaryData, CreateEntryBodyData, EditEntryData, DeletedGlossaryEntry } from './glossary.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGlossary: builder.query<ApiResponse<GlossaryData>, void>({
      query: () => `glossary`,
      providesTags: [RTKQueryTag.Glossary],
    }),
    createEntry: builder.mutation<ApiResponse<GlossaryData>, CreateEntryBodyData>({
      query: (body) => ({
        url: `glossary`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [RTKQueryTag.Glossary],
    }),
    updateEntry: builder.mutation<ApiResponse<GlossaryData>, EditEntryData>({
      query: (data) => ({
        url: `glossary?id=${data.id}`,
        method: 'PUT',
        body: data.body,
      }),
      invalidatesTags: [RTKQueryTag.Glossary],
    }),
    deleteEntry: builder.mutation<ApiResponse<DeletedGlossaryEntry>, string | number>({
      query: (id) => ({
        url: `glossary?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [RTKQueryTag.Glossary],
    }),
  }),
});

export const { useGetGlossaryQuery, useCreateEntryMutation, useUpdateEntryMutation, useDeleteEntryMutation } =
  extendedApiSlice;
